export default __webpack_public_path__ + "static/media/08_shield 2.862f59ee.gif";